// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"3d3d5dcf","58":"4b46c3e4","422":"78ce91f1"}[chunkId] + ".chunk.js";
};